module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAAXNSR0IArs4c6QAAASxJREFUOE+tkk0rhFEYhq+b3zJRU5oiUrMYC4WiRCRCYuEX2Pn4G2oSMSUbCxsrewsLC2WjlLVfQLeOzuJ9J/POMe88q7N47utc5zmP6EPZrgMNlWHZngROgGmg3hPM9jhwDMxGmXtJM/+C2R6NJnNANjsh6TEJZrsWTRbaIEHsTtJ8OBTCbI8AR8Bih14DY5KeOsJsVyNkCRgo+KRbSeGi38qZ2R4GDoHVLpCQDVY1Sc85mO1KhKwBg4nrciNpJdsr2w1gowsk7NNQ2yVVSS85WIqF7VNgL9PbkrTenk1djSawE8PfQLB67RV2BmzH8IWkrb9elGp2DmwCX2F2kt7KwC6BMKOmpN1Oc041awHLQEXSe1nYNfApab/o91PNroADSR/9gE1Jeui2kz8Y/1/FVPaa2AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/Address.png
// module id = L5/5
// module chunks = 2